import { FC } from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { IoIosArrowForward } from 'react-icons/io';
import cn from 'classnames';

import { IOPopperGroupsProps } from './OPopper.types';
import styles from './OPopper.module.scss';

const OPopperGroups: FC<IOPopperGroupsProps> = ({ groups, customStyles, handleSubmenuToggle }) => {
  return (
    <>
      {groups.map((group, gi) => (
        <Box key={gi} className={styles.groupBox}>
          {group.label && (
            <Box className={styles.label} style={customStyles?.label}>
              {group.label}
            </Box>
          )}

          {group.actions.map((action, ai) => {
            const hasSubmenu = !!action.submenu;
            const submenuEmpty = hasSubmenu && (!action.submenu || action.submenu.length === 0);
            const isDisabled = action.disabled || (hasSubmenu && submenuEmpty);

            return (
              <Box
                key={ai}
                role="menuitem"
                className={cn(styles.menuItem, { [styles.disabled]: isDisabled })}
                style={customStyles?.menuItem}
                onClick={(e) => {
                  if (isDisabled) return;

                  if (hasSubmenu) {
                    e.stopPropagation();
                    handleSubmenuToggle(action, e.currentTarget);
                  } else {
                    action.onClick?.();
                  }
                }}
              >
                {action.icon}
                {action.label}
                {hasSubmenu && (
                  <span className={styles.submenuArrow}>
                    <IoIosArrowForward />
                  </span>
                )}
              </Box>
            );
          })}

          {/* Divider */}
          {group.showDivider && <Divider flexItem className={styles.divider} />}
        </Box>
      ))}
    </>
  );
};

export default OPopperGroups;
